/**
 * Composer file pick + optional in-place replace by attachment id.
 * Replace never auto-sends. Cancel (empty list) and failed upload leave attachments unchanged.
 */

export function beginReplaceAt(replaceIdRef, fileRef, attachmentId) {
  replaceIdRef.current = attachmentId;
  if (fileRef.current) fileRef.current.value = "";
  fileRef.current?.click();
}

export function clearReplaceIntent(replaceIdRef) {
  replaceIdRef.current = null;
}

/**
 * @param {object} opts
 * @param {FileList|File[]|null} opts.fileList
 * @param {React.MutableRefObject<string|null>} opts.replaceIdRef
 * @param {React.MutableRefObject<HTMLInputElement|null>} opts.fileRef
 * @param {(fd: FormData) => Promise<object>} opts.uploadFile
 * @param {Function} opts.setAttachments
 * @param {Function} opts.setUploading
 * @param {Function} opts.setError
 */
export async function handleComposerFilesSelected({
  fileList,
  replaceIdRef,
  fileRef,
  uploadFile,
  setAttachments,
  setUploading,
  setError,
}) {
  const arr = Array.from(fileList || []);
  const replaceId = replaceIdRef.current;
  replaceIdRef.current = null;
  if (!arr.length) {
    if (fileRef.current) fileRef.current.value = "";
    return;
  }
  setUploading(true);
  setError("");
  let usedReplace = false;
  for (const f of arr) {
    const fd = new FormData();
    fd.append("file", f);
    try {
      const res = await uploadFile(fd);
      if (!usedReplace && replaceId != null && replaceId !== "") {
        usedReplace = true;
        setAttachments((prev) => {
          const idx = prev.findIndex((a) => a && a.id === replaceId);
          if (idx < 0) return [...prev, res];
          const next = [...prev];
          next[idx] = res;
          return next;
        });
      } else {
        setAttachments((prev) => [...prev, res]);
      }
    } catch (e) {
      setError(e?.response?.data?.detail || "Upload failed");
    }
  }
  setUploading(false);
  if (fileRef.current) fileRef.current.value = "";
}
